module.exports = __webpack_public_path__ + "./jiudi_b591d7871c8faa0ae0a08c19b6004b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/jiudi.png
// module id = 470
// module chunks = 0